import {
  isCensusIntegration,
  isZapierIntegration,
} from '@modules/integrationsV2/utils';
import {
  IntegrationChannelType,
  IntegrationChannelViewFragment,
} from 'generated/graphql';

export const getShouldHideConnectCTA = (
  integrationChannel: IntegrationChannelViewFragment,
) => {
  return (
    integrationChannel.type === IntegrationChannelType.Twitter ||
    isZapierIntegration(integrationChannel) ||
    isCensusIntegration(integrationChannel)
  );
};
